import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-order-details-card-view',
  templateUrl: './order-details-card-view.component.html',
  styleUrls: ['./order-details-card-view.component.scss'],
})
export class OrderDetailsCardViewComponent {
  @Input() headerName: string;
}